<template>
  <div class="svg-container stars">
    <svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 1075 213.1" style="enable-background:new 0 0 1075 213.1;" xml:space="preserve">
    <g >
      <g id="background">
        <polygon class="star st0"
                 points="666,84.9 668.5,89.5 673,92 668.5,94.5 666,99.1 663.5,94.5 658.9,92 663.5,89.5"/>
        <polygon class="star st1"
                 points="489,91.6 490.9,95.1 494.3,96.9 490.9,98.8 489,102.2 487.1,98.8 483.7,96.9 487.1,95.1"/>
        <polygon class="star st1"
                 points="365.5,128.4 368,133 372.5,135.5 368,138 365.5,142.6 363,138 358.4,135.5 363,133"/>
        <polygon class="star st1"
                 points="337,97.7 338.5,100.4 341.1,101.8 338.5,103.3 337,106 335.5,103.3 332.8,101.8 335.5,100.4"/>
        <polygon class="star st1" points="4.9,17.1 6.7,20.3 9.9,22 6.7,23.8 4.9,27 3.2,23.8 0,22 3.2,20.3"/>
        <polygon class="star st1"
                 points="516.5,74.4 517.9,77 520.5,78.4 517.9,79.8 516.5,82.4 515.1,79.8 512.5,78.4 515.1,77"/>
        <polygon class="star st1"
                 points="463.6,60.6 465,63.2 467.5,64.6 465,66 463.6,68.6 462.2,66 459.6,64.6 462.2,63.2"/>
        <polygon class="star st2"
                 points="950,25.9 952.5,30.5 957.1,33 952.5,35.5 950,40.1 947.5,35.5 943,33 947.5,30.5"/>
        <polygon class="star st2"
                 points="883.5,37 884.7,39.2 887,40.5 884.7,41.8 883.5,44 882.2,41.8 879.9,40.5 882.2,39.2"/>
        <polygon class="star st2"
                 points="937.7,72.2 939,74.5 941.3,75.8 939,77 937.7,79.3 936.5,77 934.2,75.8 936.5,74.5"/>
        <polygon class="star st2"
                 points="1042.7,19.2 1044,21.5 1046.3,22.8 1044,24 1042.7,26.3 1041.5,24 1039.2,22.8 1041.5,21.5"/>
        <polygon class="star st2"
                 points="276.2,15.7 277.5,18 279.8,19.2 277.5,20.5 276.2,22.8 275,20.5 272.7,19.2 275,18"/>
        <polygon class="star st0"
                 points="720,38.1 721.7,41.3 724.8,43 721.7,44.7 720,47.9 718.3,44.7 715.1,43 718.3,41.3"/>
        <polygon class="star st0"
                 points="715.3,87.9 717,91 720.1,92.7 717,94.4 715.3,97.6 713.5,94.4 710.4,92.7 713.5,91"/>
        <polygon class="star st0"
                 points="332.3,34.2 334.2,37.8 337.7,39.7 334.2,41.7 332.3,45.2 330.3,41.7 326.8,39.7 330.3,37.8"/>
        <polygon class="star st0"
                 points="58.5,45.7 61.3,50.8 66.4,53.6 61.3,56.3 58.5,61.4 55.8,56.3 50.7,53.6 55.8,50.8"/>
        <circle class="st3" cx="87" cy="8" r="3"/>
        <circle class="st3" cx="98.5" cy="83.5" r="2.1"/>
        <circle class="st3" cx="62.9" cy="15" r="2.1"/>
        <circle class="st3" cx="383.9" cy="87" r="2.1"/>
        <circle class="st3" cx="408.9" cy="42" r="2.1"/>
        <circle class="st3" cx="341.9" cy="12" r="2.1"/>
        <circle class="st3" cx="687.9" cy="132" r="2.1"/>
        <circle class="st3" cx="627.9" cy="112" r="2.1"/>
        <path class="st3" d="M967,101c0,1.1-0.9,2.1-2.1,2.1c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1c0,0,0,0,0,0
          C966.1,98.9,967,99.9,967,101z"/>
        <path class="st3" d="M1052,71c0,1.1-0.9,2.1-2.1,2.1c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1c0,0,0,0,0,0
          C1051.1,68.9,1052,69.9,1052,71z"/>
        <circle class="st3" cx="683.9" cy="188" r="2.1"/>
        <circle class="st3" cx="668" cy="159" r="2.1"/>
        <circle class="st3" cx="579" cy="82" r="2.1"/>
        <path class="st3" d="M540.9,51c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S540.9,50.4,540.9,51z"/>
        <circle class="st3" cx="405" cy="145" r="1"/>
        <circle class="st3" cx="552" cy="10" r="1"/>
        <circle class="st3" cx="651" cy="50" r="1"/>
        <circle class="st3" cx="488" cy="25" r="1"/>
        <circle class="st3" cx="282" cy="56" r="1"/>
        <circle class="st3" cx="240" cy="22" r="1"/>
        <circle class="st3" cx="821" cy="17" r="1"/>
        <circle class="st3" cx="800" cy="54" r="1"/>
        <circle class="st3" cx="648" cy="1" r="1"/>
        <circle class="st3" cx="653" cy="212" r="1"/>
        <circle class="st3" cx="959" cy="143" r="1"/>
        <circle class="st3" cx="993" cy="53" r="1"/>
        <circle class="st3" cx="1074" cy="4" r="1"/>
        <circle class="st3" cx="533" cy="106" r="1"/>
      </g>
    </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Stars'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .svg-container {
    position: absolute;
    top: 0;
    z-index: 0;
    width: 100%;
  }

  .st0 {
    fill: #FFEE85;
  }

  .st1 {
    fill: #FEE64F;
  }

  .st2 {
    fill: #FEE54A;
  }

  .st3 {
    fill: #FFF9D4;
  }
</style>



// WEBPACK FOOTER //
// src/components/Background/Stars.vue